export default __webpack_public_path__ + "static/media/iphonex_top.3aa50713.png";